import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_test_noise_exposure_levels_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_test_noise_exposure_levels_in_line_w_legal_reqs',
  name: 'Does the facility test noise exposure levels in line with legal requirements? ',
  description:
    '"Noise testing" refers to measuring sound exposure levels in the facility. Specifically in areas where noise exposure levels are the highest (e.g. next to loud machinery). Testing might include baseline testing and periodic testing (i.e. every six months, annually, etc.)\r\r\n\r\r\nTesting of exposure levels may be a combination of area samples with a sound level meter for general mapping/risk assessment and personal dosimetry (measurement of the \'dose\' of noise collected in the hearing zone of the worker). \r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-3--2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13430,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
